import React from 'react';
import { Reveal } from './Reveal';
const items = [{
  quote: "J'ai planifié toutes mes interventions en une seule soirée. Maintenant chaque séance a un objectif clair et j'entre en cabinet avec une totale confiance.",
  name: 'Marie D.',
  role: 'Paris · Orthopédagogue en cabinet libéral'
}, {
  quote: 'Mes patients progressent beaucoup plus vite. Les progressions sont logiques et les familles remarquent l\u2019évolution chaque semaine.',
  name: 'Sophie L.',
  role: 'Lyon · Psychologue scolaire'
}, {
  quote: "Je ne passe plus des heures à chercher des supports sur internet. J'ouvre le Protocole Clinique et je trouve tout ce dont j'ai besoin.",
  name: 'Camille T.',
  role: 'Bordeaux · Rééducatrice en cabinet'
}];
export function TestimonialStrip() {
  return <section className="w-full bg-black px-4 py-16" data-id="element-248">
      <div className="mx-auto grid max-w-6xl gap-6 md:grid-cols-3" data-id="element-249">
        {items.map((t, i) => <Reveal key={t.name} delay={i * 0.08} data-id="element-250">
            <figure className="flex h-full flex-col rounded-2xl border border-ink-border bg-ink-card p-6" data-id="element-251">
              <div className="mb-3 text-gold" data-id="element-252">⭐⭐⭐⭐⭐</div>
              <blockquote className="flex-1 text-sm leading-relaxed text-white/80" data-id="element-253">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-5" data-id="element-254">
                <div className="font-bold text-white" data-id="element-255">{t.name}</div>
                <div className="text-xs text-white/50" data-id="element-256">{t.role}</div>
              </figcaption>
            </figure>
          </Reveal>)}
      </div>
    </section>;
}